import { CDN2 } from '@/helpers/api';
import { setLastPageVisited } from '@helpers/history';
import { isServer } from '@utils/isServer';
import { Layout } from 'antd';
import { observer } from 'mobx-react';
import dynamic from 'next/dynamic';
import NextHead from 'next/head';
import React, { useEffect } from 'react';

const { Content } = Layout;

const NavBar = dynamic(() => import('@/components2/NavBar'));
const AntFooter = dynamic(() => import('@/components2/Footer'));
const AntFooterNew = dynamic(() => import('@/components2/Footer'), {
  ssr: false,
});

export function reportWebVitals(metric: { label: string }) {
  if (metric.label === 'custom') {
    ;//console.log(metric);
  }
}

const DefaultLayout = ({ children, airports, newFooter = false }) => {
  useEffect(() => {
    setLastPageVisited();
  });

  return (
    <Layout className="min-h-screen">
      <NextHead>
        <meta
          property="og:url"
          content={!isServer ? window.location.toString() : undefined}
          key="url"
        />
        <meta property="og:type" content="website" key="og:type" />
        <meta property="og:title" content="On Air Parking" key="og:title" />
        <meta
          property="og:description"
          content="Affordable Quality Parking"
          key="og:description"
        />
        <meta
          property="og:image"
          content={CDN2() + '/staticmyapp/oglogo-white.png'}
          key="og:image"
        />
      </NextHead>
      <NavBar airports={airports} />
      <Content className="site-layout">{children}</Content>
      <AntFooterNew />
    </Layout>
  );
};

export default observer(DefaultLayout);
